import { AlertCircle } from 'lucide-react';
import {
  Tooltip as TWTooltip,
  TooltipTrigger as TWTooltipTrigger,
  TooltipContent as TWTooltipContent,
  TooltipProvider,
} from '../tailwind/ui/tooltip';

interface TooltipProps {
  children?: React.ReactNode;
  size?: number;
  text: string | React.ReactNode;
  asChild?: boolean;
  title?: string;
}

export function Tooltip({
  children,
  text,
  title,
  size = 16,
  asChild = false,
}: TooltipProps) {
  return (
    <TooltipProvider>
      <TWTooltip data-testid="tooltip">
        <TWTooltipTrigger asChild>
          <span className="flex items-center gap-1 text-sm">
            {children ?? <AlertCircle size={size} />}
            {title}
          </span>
        </TWTooltipTrigger>
        <TWTooltipContent title={title}>
          {typeof text === 'string' ? <p>{text}</p> : text}
        </TWTooltipContent>
      </TWTooltip>
    </TooltipProvider>
  );
}
